import { render, staticRenderFns } from "./AffiliateForm.vue?vue&type=template&id=161bcd49&scoped=true&"
import script from "./AffiliateForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateForm.vue?vue&type=style&index=0&id=161bcd49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bcd49",
  null
  
)

export default component.exports